/**
 * Vue prop definition for class-based styling.
 * Accepts string, object, or array values compatible with Vue's class binding syntax.
 *
 * @example
 * ```vue
 * <script setup lang="ts">
 * const props = defineProps({
 *   class: classProp
 * })
 * </script>
 *
 * <!-- Usage -->
 * <MyComponent :class="'btn btn-primary'" />
 * <MyComponent :class="{ active: isActive }" />
 * <MyComponent :class="['btn', { 'btn-primary': isPrimary }]" />
 * ```
 */
export const classProp = [String, Object, Array];
//# sourceMappingURL=classProp.js.map